<x-position-definer-form
  (formCompleted)="onFormCompleted($event)"
></x-position-definer-form>
